import React, { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";

//*MUI
import Modal from "@mui/material/Modal";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import Close from "../../Components/Icons/Close";

//*Redux
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";

//*files
import cssClasses from "./LogOutSession.module.css";
import Button from "../../Subcomponents/Button";
import logo from '../../Assets/Images/vjLogo.jpg';
import strip1 from "../../Assets/Images/strip1.svg";
import strip2 from "../../Assets/Images/strip2.svg";
import strip3 from "../../Assets/Images/strip3.svg";
import { supabase } from "../../supabaseClient";


import { red } from "@mui/material/colors";
import { signOut } from "../../Services/LoginService";
const useStyles = makeStyles((theme) => ({
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "0rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  radioLabel: {
    fontFamily: "Inter-Medium !important",
    fontSize: "1.6rem",
    lineHeight: "2.5rem",
  },
  stepper: {
    "& .MuiLinearProgress-root": {
      backgroundColor: "rgba(82, 108, 130, 0.1) !important",
      height: "0.8rem !important",
      borderRadius: "5rem !important",
      width: "100% !important",
      "& .MuiLinearProgress-bar": {
        backgroundColor: "#155EEF !important",
      },
    },
  },
}));


function LogOutSession({open , handleClose}) {
    const [isLoginLoading, setIsLoginLoading] = useState(false);
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const session_ = supabase.auth.session();
  // const refreshToken2 = localStorage.getItem('supabase.auth.token');
  const [seconds, setSeconds] = useState(10);
  
  function closeModal() {
    console.log('Clicked');
    signOut().then(({ err }) => {
      dispatch(actions.authLogout());
      handleClose();
      navigate('/');
    });
  }
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prevSeconds) => prevSeconds - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    if (seconds === 0) {
      // Redirect to the login page
      closeModal(); // Replace '/login' with your login page URL
    }
  }, [seconds]);
  return (
    <Modal
    open={open}
    onClose={(_, reason) => {
      if (reason !== 'backdropClick') {
        closeModal();
      }
    }}
    aria-labelledby='modal-modal-title'
    aria-describedby='modal-modal-description'
    sx={[
      {
        '.MuiBackdrop-root': {
          background: 'rgba(52, 64, 84, 0.7)',
        },
      },
    ]}
    disableAutoFocus={true}
    // button
  >
    <div className={cssClasses.wrapperPage}>
      <div className={cssClasses.backgroundImage}>
        <div className={cssClasses.registerationBlock}>
          <div className={cssClasses.headerSessionExpire}>
            <h2>Session Expired</h2>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='20'
              height='20'
              viewBox='0 0 20 20'
              fill='none'
            >
              <g clip-path='url(#clip0_1883_8735)'>
                <path
                  d='M10.0001 13.3333V9.99996M10.0001 6.66663H10.0084M18.3334 9.99996C18.3334 14.6023 14.6025 18.3333 10.0001 18.3333C5.39771 18.3333 1.66675 14.6023 1.66675 9.99996C1.66675 5.39759 5.39771 1.66663 10.0001 1.66663C14.6025 1.66663 18.3334 5.39759 18.3334 9.99996Z'
                  stroke='white'
                  stroke-width='2'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                />
              </g>
              <defs>
                <clipPath id='clip0_1883_8735'>
                  <rect width='20' height='20' fill='white' />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div
            style={{
              padding: '1rem',
            }}
          >
            <div className={classes.title}>
              <h4>Your Session has expired</h4>
              <p>
                You will be redirected to the Login Page in{' '}
                <span style={{ color: 'red' }}>({seconds} sec)</span>
              </p>
            </div>
            <div className={cssClasses.logoutButton}>
              <Button
                style={{
                  display: 'flex',
                  padding: '0.75rem 2rem',
                  borderRadius: '1rem',
                  width: 'auto',
                  backgroundColor: '#1570EF',
                  color: '#FFF',
                }}
                btnName={'Log Out'}
                clicked={closeModal}
                isLoading={isLoginLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
  );
}

export default LogOutSession;